import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';

import { AppEffects } from '../../../../apps/hosty-web/src/app/core/store/app/app.effects';
import {
  appStoreFeatureKey,
  reducer,
} from '../../../../apps/hosty-web/src/app/core/store/app/app.reducer';

import { provideAccountsStore } from './accounts-store';
import { provideAutomationsStore } from './automations-store';
import { provideDashboardStore } from './dashboard';
import { provideGroupsStore } from './groups-store';
import { provideInboxStore } from './inbox-store';
import { provideListingStore } from './listing-store';
import { PushEffects } from './push.effects';
import { provideReportsStore } from './reports-store';
import { provideReservationStore } from './reservation-store';
import { provideReviewsStore } from './reviews-store';
import { provideTeamStore } from './team-store';
import { provideUserStore } from './user-store';
import { provideVocabularyStore } from './vocabulary-store';

export function provideAppStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideStore({
      [appStoreFeatureKey]: reducer,
    }),
    provideEffects([AppEffects, PushEffects]),
    provideUserStore(),
    provideInboxStore(),
    provideListingStore(),
    provideAccountsStore(),
    provideReportsStore(),
    provideTeamStore(),
    provideReservationStore(),
    provideAutomationsStore(),
    provideVocabularyStore(),
    provideReviewsStore(),
    provideDashboardStore(),
    provideGroupsStore(),
  ]);
}
